var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCuttingInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_16_1",
    "data-name": "Component 16 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#7bb6c6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M842.411,442.827q2.275,3,4.516,6.025c.192.281,3.273,4.591,3.273,4.591-6.231-1.292-9.578-4.764-11.451-6.419a72.94,72.94,0,0,1-5.35-5.984c-.954-1.114-.42-1.474.758-2.359.935-.7.954-.747.466-1.314-2.056-2.388-3.037-3.37-5.1-5.749-.733-.837-1.445-1.689-2.177-2.526-.248-.285-.214-.552.333-.923.472-.321.921-.694,1.374-1.042.9-.692.958-.7,1.392-.135C833.233,430.62,841.179,441.2,842.411,442.827Z",
    transform: "translate(-817.698 -420.015)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCuttingInstructions);
export default __webpack_public_path__ + "static/media/icon-cuttingInstructions.1f835f15bcda620025f21ca5b979a1ed.svg";
export { ForwardRef as ReactComponent };